import PrTypengTitleComponent from './pr-typimg-title';

export default PrTypengTitleComponent;